import { Button, Divider, Tag } from "antd";
import styled, { css } from "styled-components";

export const FlexHeader = styled.div`
  display: flex;
  flex-direction: column;
  flex-wrap: wrap;
  width: 100%;
  transition: height 1s;
  overflow: hidden;

  ${({ areFiltersAvailable, filterDirection }) =>
    `
  top: ${
    filterDirection === "horizontal" && areFiltersAvailable ? "70px" : "0"
  };
  
  ${
    filterDirection === "horizontal" &&
    css`
      @media (min-width: 650px) {
        flex-direction: row;
        position: absolute;

        .bnly-search__filtering-title {
          display: none;
        }

        .bnly-search__filter-tag {
          flex: 0 0 auto;
        }

        .bnly-search__filter-divider {
          display: none;
        }
      }
    `
  }`}

  @media only screen and (max-width: 767px) {
    padding-left: 20px;
    padding-right: 20px;
    flex-wrap: nowrap;
    max-width: calc(100% + 20px);
    width: calc(100% + 20px);
    overflow: scroll;
    display: ${(props) => (props.showMobile ? "flex" : "none")};
  }
`;

export const CustomFilteringTitle = styled.h5`
  font-size: 14px;
  padding: 0;
  margin: 15px 0 7px 10px;
  border: none;

  @media only screen and (max-width: 767px) {
    font-size: 12px;
    margin: 5px 0;
  }
`;

export const CustomTag = styled(Tag)`
  display: flex;
  justify-content: space-between;
  align-items: center;

  width: fit-content;

  white-space: normal;
  word-break: break-word;

  font-size: 14px;
  line-height: 25px;
  padding: 0 10px;
  margin: 0 0 5px 10px;

  @media only screen and (max-width: 767px) {
    line-height: 19px;
    padding: 0 7px;
    font-size: 12px;
    margin: 0 0 3px 0;
  }

  .ant-tag-close-icon {
    padding: 4px;
    color: rgba(0, 0, 0, 0.3);
    border: 1px solid rgba(0, 0, 0, 0.2);
    border-radius: 100%;
    margin: 3px 0 3px 10px;
  }
`;

export const ClearAllButton = styled(Button)`
  font-size: 14px;
  line-height: 25px;
  padding: 0 10px;
  margin: 7px 0 0 10px;
  width: max-content;

  height: 30px;
  color: #ffffff;
  background-color: var(--bn-secondary-color);
  border-radius: 5px;

  &:hover {
    color: #ffffff;
    background-color: var(--bn-secondary-color);
  }

  @media only screen and (max-width: 767px) {
    line-height: 19px;
    padding: 0 7px;
    font-size: 12px;
    margin-left: 0px;
  }

  ${({ filterDirection }) =>
    `${
      filterDirection === "horizontal" &&
      css`
        margin: 0 0 5px 10px;
      `
    }`}
`;

export const CustomDivider = styled(Divider)`
  background-color: rgba(0, 0, 0, 0.1);
  margin: 20px 0 0 0;
  width: 100%;

  @media only screen and (max-width: 767px) {
    border: none;
  }
`;
